import ButtonOutline from "components/semantic/ButtonOutline";
import React from "react";

const UnexpectedErrorPage: React.FC = () => {
  const handleReload = () => {
    window.location.reload();
  };

  const handleGoHome = () => {
    window.location.href = "/";
  };

  return (
    <div className="flex h-screen w-full items-center justify-center bg-gray-100">
      <div className="max-w-md w-full bg-white p-8 rounded-2xl shadow-lg text-center">
        <div className="flex justify-center mb-4">
          <div className="w-16 h-16 flex items-center justify-center rounded-full bg-red-100">
            <span className="text-red-600 text-4xl">⚠️</span>
          </div>
        </div>

        <h1 className="text-2xl font-bold text-gray-800 mb-2">Oops! Something went wrong</h1>
        <p className="text-gray-500 mb-6">An unexpected error has occurred. Please try reloading the page or return to the homepage.</p>

        <div className="flex justify-center gap-4">
          <ButtonOutline title="Reload" onClick={() => handleReload()} />
          <ButtonOutline title="Go Home" onClick={() => handleGoHome()} />
        </div>
      </div>
    </div>
  );
};

export default UnexpectedErrorPage;
